import RadioCampaignInvoice from './RadioCampaignInvoice';


export default class Invoices {
  radioInvoices: RadioCampaignInvoice[];

  constructor(radioInvoices) {
    this.radioInvoices = radioInvoices;
  }

  static parse(data: any) {
    const radioInvoices = data.invoices.map(i => RadioCampaignInvoice.parse(i));
    return new Invoices(radioInvoices);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/billing/domain/Invoices.js